/**
 * Utilitários centralizados de validação
 * Consolidação de todas as funções de validação da aplicação
 */

import { keepOnlyDigits } from './formatters';

// ============= VALIDAÇÃO DE DOCUMENTOS =============

/**
 * Valida CPF verificando dígitos verificadores
 */
export function validarCPF(cpf: string): boolean {
  const cleaned = keepOnlyDigits(cpf);
  
  if (cleaned.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cleaned)) return false; // 111.111.111-11
  
  // Validação dos dígitos verificadores
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digito1 = resto >= 10 ? 0 : resto;
  
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digito2 = resto >= 10 ? 0 : resto;
  
  return parseInt(cleaned.charAt(9)) === digito1 && 
         parseInt(cleaned.charAt(10)) === digito2;
}

/**
 * Valida CNPJ verificando dígitos verificadores
 */
export function validarCNPJ(cnpj: string): boolean {
  const cnpjOnly = keepOnlyDigits(cnpj);
  
  if (cnpjOnly.length !== 14) return false;
  
  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cnpjOnly)) return false;
  
  // Calcular dígitos verificadores
  let soma = 0;
  let peso = 2;
  
  // Primeiro dígito verificador
  for (let i = 11; i >= 0; i--) {
    soma += parseInt(cnpjOnly[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  
  const digito1 = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (parseInt(cnpjOnly[12]) !== digito1) return false;
  
  // Segundo dígito verificador
  soma = 0;
  peso = 2;
  
  for (let i = 12; i >= 0; i--) {
    soma += parseInt(cnpjOnly[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  
  const digito2 = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return parseInt(cnpjOnly[13]) === digito2;
}

/**
 * Valida CEP (formato básico)
 */
export function validarCEP(cep: string): boolean {
  const cepOnly = keepOnlyDigits(cep);
  return cepOnly.length === 8;
}

/**
 * Valida telefone brasileiro (10 ou 11 dígitos com DDD)
 */
export function validarTelefone(telefone: string): boolean {
  const telOnly = keepOnlyDigits(telefone);
  // Aceita 10 dígitos (fixo) ou 11 dígitos (celular com 9)
  return telOnly.length === 10 || telOnly.length === 11;
}

/**
 * Valida e-mail usando regex padrão
 */
export function validarEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
